import { MenuItem, TextField } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  setTooltipContent,
  setTooltipStyle,
  setCurrentStep,
} from "../../redux";
import {
  getCurrentHotspot,
  getCurrentStep,
  getHoverActionTooltipContent,
  getHoverActionTooltipStyle,
} from "../../redux/selectors";
import debounce from "lodash.debounce";
import { TextEditor } from "../TextEditor/TextEditor";
import { stripBr } from "../../util/general";
import { useStyles } from "../../util/useStyles";
import { steps } from "../../util/constants";
import Label from "../Label/Label";
import Section from "../Section/Section";

export const ConfigureHoverAction = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const debouncedDispatch = debounce(dispatch, 400);
  const hotspotIndex = useSelector(getCurrentHotspot);
  const currentStep = useSelector(getCurrentStep);
  const tooltipContent =
    stripBr(useSelector(getHoverActionTooltipContent)) ?? "";
  const tooltipStyle = useSelector(getHoverActionTooltipStyle) ?? "default";
  const handleTooltipContentChange = (e) => {
    const html = e.target.value.replace(/\n/g, "<br/>\n");
    debouncedDispatch(
      setTooltipContent({
        hotspotIndex,
        value: html,
      })
    );
  };
  const handleTooltipStyleChange = (e) => {
    const { value } = e.target;
    dispatch(setTooltipStyle({ hotspotIndex, value }));
  };

  return (
    <Section
      title="Tooltip"
      onClick={() => dispatch(setCurrentStep(steps.configureHoverAction))}
      {...props}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      ></div>
      <div style={{ padding: "0 1rem 0 1rem" }}>
        <TextEditor
          initialValue={tooltipContent}
          onChange={handleTooltipContentChange}
          autoFocus={steps.configureHoverAction === currentStep}
        />
        <div className="configureMessageHeaderContainer">
          <div>
            <Label>Tooltip style</Label>
          </div>
          <div className="configureMessageHeaderSpacer" />
          <TextField
            className="configureMessageHeaderRight"
            id="tooltip-style-select"
            select
            value={tooltipStyle}
            onChange={handleTooltipStyleChange}
            size="small"
            variant="outlined"
            InputProps={{
              classes: {
                input: classes.menuItem,
              },
            }}
          >
            <MenuItem value="sirv-hotspot-tooltip--default">Default</MenuItem>
            <MenuItem value="sirv-hotspot-tooltip--balloon">Balloon</MenuItem>
          </TextField>
        </div>
      </div>
    </Section>
  );
};
